<template>
    <Pie :chart-id="chartId" :dataset-id-key="datasetIdKey" :chart-options="chartOptions" :chart-data="chartData"
        :width="width" :height="height" />
</template>

<script>
import { Pie } from "vue-chartjs";
import { Chart as ChartJS, Title, Tooltip, Legend, CategoryScale, LinearScale, ArcElement } from "chart.js"

ChartJS.register(Title, Tooltip, Legend, CategoryScale, LinearScale, ArcElement);

export default {
    name: "PieChart",
    components: {
        Pie
    },
    props: {
        data: {
            required: true,
            type: Array
        },
        labels: {
            required: true,
            type: Array
        },
        chartId: {
            type: String,
            default: "pie-chart"
        },
        datasetIdKey: {
            type: String,
            default: "label"
        },        
        width: {
            type: Number,
            default: 200
        },
        height: {
            type: Number,
            default: 200
        },
        cssClasses: {
            default: "",
            type: String
        }
    },
    data() {
        return {
            chartData: {
                labels: this.labels,
                datasets: [{
                    borderWidth: 1,
                    borderColor: [
                        'rgba(0, 153, 255, 1)',
                        'rgba(0, 204, 102, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)'
                    ],
                    backgroundColor: [
                        'rgba(0, 153, 255, 1)',
                        'rgba(0, 204, 102, 1)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                    ],
                    data: this.data
                }]
            },
            chartOptions: {
                plugins: {
                    legend: {
                        display: false
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 0, // general animation time
                },
                hover: {
                    animationDuration: 0, // duration of animations when hovering an item
                },
                responsiveAnimationDuration: 0, // animation duration after a resize
            }
        }
    },
    watch: {
        data: function (newData) {
            this.chartData.datasets[0].data = newData;
        },
        labels: function (newLabels) {
            this.chartData.labels = newLabels;
        }
    }
}
</script>
